import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './EmptyInsights.styles';

export const EmptyInsights = () => {
  const { t } = useTranslation('insights');

  return (
    <S.Container data-testid="empty-insights">
      <S.Wrapper>
        <S.Img
          src="/app/static/images/empty-state/no-search-result.svg"
          alt=""
        />
        <S.Title>{t('insightsGroup.empty.title')}</S.Title>
        <S.Description>{t('insightsGroup.empty.description')}</S.Description>
      </S.Wrapper>
    </S.Container>
  );
};
